<template>
  <div class="partners">
    <div class="title">
      <p>合作伙伴</p>
      <span>cooperative partner</span>
      <i></i>
    </div>
    <div class="con">
      <a :href="item.link_url" v-for="(item, index) in list" :key="index">
        <div class="img">
          <img :src="item.link_image" alt="" />
        </div>
        <div class="title">{{ item.link_name }}</div>
      </a>
    </div>
  </div>
</template>

<script>
import service from './partners'

export default {
  name: 'partners',
  data () {
    return {
      pagesize: 6,
      total: 0,
      page: 1,
      list: []
    }
  },
  created () {
    service.getLinksList(this)
  }
}
</script>

<style lang="scss" scoped>
@import "./partners";
</style>



// WEBPACK FOOTER //
// src/components/index/partners/partners.vue